import { getCookie } from "./getCookie";
import { createApi } from "./createApi";
import Cookies from "universal-cookie";
import { createRefreshApi } from "./createRefreshApi";
import { logger } from "../../utils/logger";

export const getRefreshToken = async (navigate: any, retryFunction: any) => {
  const ActuateUI = createRefreshApi(``);
  const refreshToken = getCookie("token_secret");
  const article = { refresh_token: refreshToken };

  if (refreshToken) {
    await ActuateUI.post(`/auth/refresh/`, article)
      .then(async (response) => {
        const apiResponse = response.data;

        // Use centralized auth state management
        const { authStateManager } = await import("./authStateManager");
        authStateManager.setAuthState(
          apiResponse.token,
          apiResponse.token_secret
        );

        localStorage.setItem("tokenRefreshing", "false");
        if (retryFunction) {
          retryFunction();
        }
      })
      .catch((err) => {
        logger.log(err);

        // Use centralized auth state management for clearing
        import("./authStateManager").then(({ authStateManager }) => {
          authStateManager.clearAuthState();
        });

        localStorage.setItem("tokenRefreshing", "false");
        // Redirect to Cognito instead of /login
        import("../pages/Login").then(({ handleRedirect }) => {
          handleRedirect();
        });
      });
  } else {
    localStorage.setItem("tokenRefreshing", "false");

    // Use centralized auth state management for clearing
    import("./authStateManager").then(({ authStateManager }) => {
      authStateManager.clearAuthState();
    });

    // Redirect to Cognito instead of /login
    import("../pages/Login").then(({ handleRedirect }) => {
      handleRedirect();
    });
  }
};
